import { ListEmptyState } from "../../empty-state";
import { useHubTableContext } from "../hub-table.context";

/** Vazio padrão (`ListEmptyState`) com os textos do Root; o `HubTable.Empty` da tela o substitui. */
export function HubTableEmptyDefault() {
  const { empty, onClear, partTestId } = useHubTableContext();

  return (
    <ListEmptyState
      noun={empty.noun}
      gender={empty.gender}
      plural={empty.plural}
      hasSearch={empty.hasSearch}
      hasFilters={empty.hasFilters}
      onClear={onClear}
      testId={partTestId("empty") ?? "hub-table-empty"}
    />
  );
}
HubTableEmptyDefault.displayName = "HubTable.EmptyDefault";
